import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useHttpClient } from '@bonusly/http-client';

import { AgendaTopicAPIData, SuggestedTopicAPIData } from '../../../types/growth-api';
import { QueryKey } from '../../../types/growth-query-key';

type CreateTopicParams = {
	category_id: string;
	meeting_id: string;
	title: string;
	repeats: boolean;
};

type UpdateSuggestedTopic = {
	suggested_topic_id: string;
	agenda_topic_id: string;
};

export const useAddToDiscussion = (suggestedTopicId: string, meetingId: string, categoryId: string, title: string) => {
	const http = useHttpClient();
	const queryClient = useQueryClient();

	const createTopic = useMutation(async (topic: CreateTopicParams): Promise<AgendaTopicAPIData> => {
		const res = await http.post<AgendaTopicAPIData>(`/one_on_ones/agenda_topics`, topic);
		return res.data;
	});

	const updateSuggestedTopic = useMutation(async (params: UpdateSuggestedTopic): Promise<SuggestedTopicAPIData> => {
		const res = await http.patch<SuggestedTopicAPIData>(`/one_on_ones/suggested_topics/${params.suggested_topic_id}`, {
			agenda_topic_id: params.agenda_topic_id,
		});
		queryClient.invalidateQueries([QueryKey.Meeting, meetingId]);

		return res.data;
	});

	const handleAddToDiscussion = async () => {
		const agendaTopic = await createTopic.mutateAsync({
			category_id: categoryId,
			meeting_id: meetingId,
			title: title,
			repeats: true,
		});

		await updateSuggestedTopic.mutateAsync({
			suggested_topic_id: suggestedTopicId,
			agenda_topic_id: agendaTopic.id,
		});
	};

	const isLoading = createTopic.isLoading || updateSuggestedTopic.isLoading;

	return { handleAddToDiscussion, isLoading };
};
